export default __webpack_public_path__ + "static/media/myWebsite.0b870159.png";